import { LoadingContainer } from 'components/loadingContainer'
import { useEventByIdUser } from 'hooks/user/useEvents'
import { calculateIsSoldOut } from 'utils/event'

import { EventCardUser } from './eventCardUser'
import { Container } from './eventCardUser.style'

interface Props {
    eventId: string
    showPurchaseButton?: boolean
}

export const EventCardListing = ({ eventId, showPurchaseButton = true }: Props) => {
    const { data, isLoading, error } = useEventByIdUser(eventId)

    const isSoldOut = data && data.location ? calculateIsSoldOut(data.location, data.tickets ?? []) : false
    const sellingDateIsOverDue = data && data.selling_end_date ? new Date(data.selling_end_date) < new Date() : false
    const saleIsOver = isSoldOut || sellingDateIsOverDue

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            {data && (
                <Container saleisover={saleIsOver}>
                    <EventCardUser data={data} saleIsOver={saleIsOver} showPurchaseButton={showPurchaseButton} />
                </Container>
            )}
        </LoadingContainer>
    )
}
